import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const handleGoogleLogin = () => {
  const redirectUrl = window.location.origin + "/api/auth/google/callback";
  window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${process.env.REACT_APP_GOOGLE_CLIENT_ID}&redirect_uri=${encodeURIComponent(redirectUrl)}&response_type=code&scope=email%20profile`;
};

export default function Register() {
  const { register } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Welcome to Rooted in Amador!");
      navigate("/");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="register-page">
      <div className="text-xs tracking-wider-2 uppercase text-sage mb-3">Join the garden</div>
      <h1 className="font-display text-5xl text-darkRoast mb-10">Create account.</h1>

      <button
        onClick={handleGoogleLogin}
        className="w-full border border-darkRoast/20 py-3.5 rounded-full text-sm tracking-wider-2 uppercase text-darkRoast hover:border-sage hover:text-sage transition-colors flex items-center justify-center gap-3"
        data-testid="google-register-btn"
      >
        <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
        Continue with Google
      </button>

      <div className="flex items-center my-8 text-xs tracking-wider-2 uppercase text-earth">
        <div className="flex-1 h-px bg-darkRoast/10"></div>
        <span className="px-4">or</span>
        <div className="flex-1 h-px bg-darkRoast/10"></div>
      </div>

      <form onSubmit={submit} className="space-y-5">
        {[
          { k: "name", l: "Name", t: "text" },
          { k: "email", l: "Email", t: "email" },
          { k: "password", l: "Password", t: "password" },
        ].map(({ k, l, t }) => (
          <div key={k}>
            <label className="text-xs tracking-wider-2 uppercase text-earth">{l}</label>
            <input
              type={t} required minLength={t === "password" ? 6 : 1}
              value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })}
              className="w-full bg-transparent border-b border-darkRoast/20 py-2 focus:outline-none focus:border-sage"
              data-testid={`register-${k}`}
            />
          </div>
        ))}
        <button type="submit" disabled={loading} className="w-full bg-darkRoast text-cream py-3.5 rounded-full text-sm tracking-wider-2 uppercase hover:bg-sage transition-colors disabled:opacity-60" data-testid="register-submit">
          {loading ? "Creating…" : "Create account"}
        </button>
      </form>

      <p className="mt-8 text-sm text-earth text-center">
        Already have an account? <Link to="/login" className="text-darkRoast underline underline-offset-4 hover:text-sage" data-testid="link-login">Sign in</Link>
      </p>
    </div>
  );
}
